import SellAndRentLayout from "./SellAndRentLayout";
import SellAndRentListPage from "./pages/SellAndRentListPage";
import SellAndRentDetailPage from "./pages/SellAndRentDetailPage";

export const sellAndRentRoutes = {
  path: "sell-and-rent",
  component: SellAndRentLayout,
  children: [
    {
      name: "SellAndRentListPage",
      component: SellAndRentListPage,
      path: ""
    },
    {
      name: "SellAndRentDetailPage",
      component: SellAndRentDetailPage,
      path: ":id"
    }
  ]
};
